module.exports = __webpack_public_path__ + "static/media/code.200233bd.png";